<div class="custom-dialog warn">
  <img style="padding:5px" src="assets/img/icon.png" width="110" height="60" />
  <h2 mat-dialog-title>Well Chron: Session Timeout</h2>
  <mat-dialog-content>
    <p>
      You've been inactive for a while. For your security, you'll be signed out in
      <strong>{{ data.secondsRemaining$ | async }}</strong> seconds.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-raised-button (click)="logoutNow()">Log Out Now</button>
    <button mat-raised-button color="warn" (click)="staySignedIn()">Stay Signed In</button>
  </mat-dialog-actions>
</div>
